import ProfileShareButton from './ProfileShareButton'

export type { ProfileShareButtonProps } from './ProfileShareButton'

export default ProfileShareButton
